import { Outlet, useNavigate } from "react-router-dom";
import ContentLayout from "../../components/UI/Layout/ContentLayout.tsx";
import useTenants from "../../hooks/use-tenants";
import CandidatList from "../../components/Tenant/CandidatList";
import HeaderLayout from "../../components/UI/Layout/HeaderLayout.tsx";

function CandidatListPage() {
  const nav = useNavigate();
  const { tenants, isLoading } = useTenants();

  return (
    <>
      <ContentLayout
        header={
          <HeaderLayout
            title="Candidats"
            breadcrumb={[
              { label: "Tableau de bord", to: "/bailleur" },
              { label: "Candidats" },
            ]}
          />
        }
        body={
          <CandidatList
            tenants={tenants}
            isLoading={isLoading}
            onAdd={() => nav("add")}
          />
        }
      />

      <Outlet />
    </>
  );
}

export default CandidatListPage;
